export default __webpack_public_path__ + "static/TX4-eec27f95bf12f5201d5d640cfb4ccd1d.svg";